// src/slices/subscription/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getSubscriptions, getSubscriptionById, createSubscription, deleteSubscription, toggleSubscription } from "./thunk";

const initialState = { subscriptions: [], selectedSubscription: null, pagination: {}, loading: false, error: null };

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    clearSelectedSubscription: (state) => {
      state.selectedSubscription = null;
    }
  },

  extraReducers: (builder) => {
    builder

      // ================= GET ALL =================
      .addCase(getSubscriptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.subscriptions = action.payload?.data || [];
        state.pagination = action.payload?.pagination || {};
      })
      .addCase(getSubscriptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= GET BY ID =================
      .addCase(getSubscriptionById.fulfilled, (state, action) => {
        state.selectedSubscription = action.payload?.data;
      })

      // ================= CREATE =================
      .addCase(createSubscription.fulfilled, (state, action) => {
        const newItem = action.payload?.data;

        if (newItem) {
          state.subscriptions.unshift(newItem);
        }
      })

      // ================= DELETE =================
      .addCase(deleteSubscription.fulfilled, (state, action) => {
        state.subscriptions = state.subscriptions.filter((item) => item.id !== action.payload.id);
      })

      // ================= TOGGLE =================
      .addCase(toggleSubscription.fulfilled, (state, action) => {
        const updated = action.payload?.data;

        const index = state.subscriptions.findIndex((item) => item.id === updated?.id);

        if (index !== -1) {
          state.subscriptions[index] = updated;
        }
      });
  }
});

export const { clearSelectedSubscription } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
